import { render, staticRenderFns } from "./AddFaceModal.vue?vue&type=template&id=b52d9ac0"
import script from "./AddFaceModal.vue?vue&type=script&lang=js"
export * from "./AddFaceModal.vue?vue&type=script&lang=js"
import style0 from "./AddFaceModal.vue?vue&type=style&index=0&id=b52d9ac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports